import React from "react";
import { HeroReuse } from "../../components/common/HeroReuse";
import artcleImg from "../../assets/blogImage2.svg";
import ArticleContent from "../../components/sections/blog/ArticleContent";
import RequestDemo from "../../components/common/RequestDemo";
import { articleContent } from "../../constants/data";

const Articles = ({ title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center gap-8 sm:gap-16 lg:gap-0">
      <HeroReuse
        Title="RegTech Industry and Its Future: Transforming Compliance with Technology"
        Description="Regulatory Technology, or RegTech, is a rapidly evolving sector that leverages technology to simplify and automate regulatory processes."
        date="19 sep 2024"
        imgUrl={artcleImg}
      />
      <ArticleContent content={articleContent} />
      <RequestDemo />
    </div>
  );
};

export default Articles;
